import { z } from 'zod'

export const TokenSchema = z.object({
  token: z.string().trim().min(1, { message: 'Вставь ADMIN_TOKEN инсталляции' }),
})

export type TokenInput = z.infer<typeof TokenSchema>
